import Immutable from 'seamless-immutable';

import * as actionTypes from './action-types';

const initialState = Immutable({
  error: false,
  fetchingStart: false,
  authenticatingWithSlack: false,
  code: null,
  state: null,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SLACK_AUTH.START: {
      return state.merge({
        fetchingStart: true,
        authenticatingWithSlack: true,
      });
    }
    case actionTypes.SLACK_AUTH.SUCCESS: {
      return state.merge({
        authenticatingWithSlack: false,
        code: action.payload.code,
        state: action.payload.state,
      });
    }
    case actionTypes.SLACK_AUTH.FAILURE: {
      const { error } = action.payload;

      return state.merge({
        authenticatingWithSlack: false,
        error,
      });
    }

    default:
      return state;
  }
}
